/*
  Cross-Sell „Das passt dazu“ (Produktseite: sections/cx-xsell.liquid, Warenkorb: sections/main-cart.liquid und
  sections/maison-cart.liquid).

  Daten: Shop-Datei cx-xsell.json, täglich vom Nacht-Job gebaut (apps/lb24-checkout/build_xsell.py, Ablauf in
  apps/lb24-checkout/xsell/README-Job.md). Aufbau (Format 2): { updated, format: 2, ib, products: { "<id>": { h, t, img, p, v, nv } }, items: { "<productId>": [ [id, why], … ] } }
  (Format 1 mit Objekten je Empfehlung wird weiter gelesen, siehe normalize()).
    p   = Preis ab (€), v = erste lieferbare Variant-ID, nv = Anzahl lieferbarer Varianten, why = „Passt, weil …“-Satz.
  Die Datei wird einmal geladen und 1 h im sessionStorage gehalten.

  Container: <div data-cx-xsell="product|cart" data-cx-xsell-url="…" data-product-id="…" | data-cart-ids='[…]'
                 data-max="6" data-title="Das passt dazu" data-hide-related="true" hidden>
  Produktseite: Empfehlungen des Produkts. Hat die Datei nichts → Container bleibt versteckt, die Shopify-„Kunden
  kauften auch“ (related-products) bleibt sichtbar; sonst bekommt <html> die Klasse cx-xsell-has (versteckt related-products).
  Warenkorb: Empfehlungen aller Warenkorb-Produkte im Round-Robin vereint, ohne Dubletten und ohne Produkte, die schon
  im Warenkorb liegen.
  Karten im Stil der Berater-Karte (cxq__card aus assets/cx-refresh.css): Bild 3:2 (object-fit: contain – nichts wird
  abgeschnitten), Titel, Preis „ab X €“, „Passt, weil: …“, Button „In den Warenkorb“ (eine Variante → POST /cart/add.js)
  oder „Ansehen“ (mehrere Varianten → Produktseite).
*/
(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0416/8197/7495/';
  var CACHE_KEY = 'cx_xsell_v1';
  var CACHE_TTL = 60 * 60 * 1000;
  var imgUrl = function (path, w) { if (!path) return ''; var u = /^https?:/.test(path) ? path : CDN + path; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 600); };
  var money = function (n) {
    if (n == null) return '';
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: n % 1 ? 2 : 0 }).format(n);
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // ---------- Daten laden (einmal pro Seite, 1 h im sessionStorage) ----------
  var pending = null;
  function load(url) {
    if (pending) return pending;
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var c = JSON.parse(raw);
        if (c && c.url === url && Date.now() - c.ts < CACHE_TTL && c.data && c.data.items) { pending = Promise.resolve(normalize(c.data)); return pending; }
      }
    } catch (e) { /* kein Storage (privater Modus) – egal */ }
    pending = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('cx-xsell ' + r.status); return r.json(); }).then(function (data) {
      if (!data || !data.items) throw new Error('cx-xsell: leere Datei');
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ url: url, ts: Date.now(), data: data })); } catch (e) { /* zu groß oder gesperrt */ }
      return normalize(data);
    });
    return pending;
  }

  // Format 2 (kompakt): items = {pid: [[cid, why], …]}, products = {cid: {h, t, img, p, v, nv}}, ib = Bild-Basis-URL.
  // Wird einmal in das alte Format (items = {pid: [{id, h, t, img, p, v, nv, why}]}) aufgelöst; Format 1 bleibt unverändert.
  function normalize(data) {
    if (!data.products) return data;
    var out = { updated: data.updated, items: {} }, ib = data.ib || '';
    Object.keys(data.items).forEach(function (pid) {
      out.items[pid] = data.items[pid].map(function (r) {
        if (!Array.isArray(r)) return r;
        var p = data.products[String(r[0])] || {};
        var img = p.img || '';
        if (img && img.indexOf('http') !== 0) img = ib + img;
        return { id: String(r[0]), h: p.h, t: p.t, img: img, p: p.p, v: p.v, nv: p.nv, why: r[1] };
      }).filter(function (it) { return it.h; });
    });
    return out;
  }

  // ---------- Auswahl ----------
  function pick(data, ids, exclude, max) {
    var lists = ids.map(function (id) { return (data.items && data.items[String(id)]) || []; }).filter(function (l) { return l.length; });
    var seen = {}, out = [];
    exclude.forEach(function (id) { seen[String(id)] = true; });
    // Round-Robin über die Listen aller Produkte: 1. Empfehlung von A, 1. von B, 2. von A, …
    for (var i = 0; out.length < max; i++) {
      var any = false;
      for (var l = 0; l < lists.length && out.length < max; l++) {
        if (i >= lists[l].length) continue;
        any = true;
        var it = lists[l][i];
        if (seen[String(it.id)]) continue;
        seen[String(it.id)] = true;
        out.push(it);
      }
      if (!any) break;
    }
    return out;
  }

  // ---------- Karte ----------
  function card(it, i) {
    var href = root + 'products/' + encodeURIComponent(it.h);
    var price = it.p != null ? 'ab ' + money(it.p) : '';
    var canAdd = it.v && Number(it.nv) === 1;
    var btn = canAdd
      ? '<button type="button" class="cxx__btn" data-cxx-add="' + esc(it.v) + '" data-cxx-title="' + esc(it.t) + '">In den Warenkorb</button>'
      : '<a class="cxx__btn cxx__btn--ghost" href="' + esc(href) + '">Ansehen</a>';
    return '<div class="cxq__card cxx__card">' +
      '<a class="cxq__card-media" href="' + esc(href) + '" tabindex="-1" aria-hidden="true">' +
        (it.img ? '<img src="' + esc(imgUrl(it.img, 600)) + '" alt="" decoding="async" loading="' + (i < 3 ? 'eager' : 'lazy') + '">' : '') +
      '</a>' +
      '<div class="cxq__card-body">' +
        '<a class="cxq__card-title" href="' + esc(href) + '">' + esc(it.t) + '</a>' +
        (price ? '<span class="cxq__card-price">' + esc(price) + '</span>' : '') +
        (it.why ? '<span class="cxq__why"><b>Passt, weil:</b> ' + esc(it.why) + '</span>' : '') +
        btn +
      '</div></div>';
  }

  function render(el, items, title) {
    el.innerHTML =
      '<div class="cxx__head"><h2 class="cxx__title">' + esc(String(title || 'Das passt dazu').replace(/\s*:\s*$/, '')) + '</h2></div>' +
      '<div class="cxq__slider-wrap">' +
        '<button type="button" class="cxq__arrow cxq__arrow--prev" data-cxq-nav="-1" aria-label="Zurück">&#8249;</button>' +
        '<div class="cxq__slider" data-cxq-slider>' + items.map(card).join('') + '</div>' +
        '<button type="button" class="cxq__arrow cxq__arrow--next" data-cxq-nav="1" aria-label="Weiter">&#8250;</button>' +
      '</div>';
    el.hidden = false;
    initSlider(el);
  }

  // Slider wie im Berater: Pfeile scrollen um eine Karte, am Rand ausgegraut; auf Touch wird gewischt
  function initSlider(el) {
    var wrap = el.querySelector('.cxq__slider-wrap'), track = wrap && wrap.querySelector('[data-cxq-slider]');
    if (!track) return;
    var prev = wrap.querySelector('.cxq__arrow--prev'), next = wrap.querySelector('.cxq__arrow--next');
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
      wrap.classList.toggle('has-overflow', max > 1);
    }
    wrap.querySelectorAll('[data-cxq-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cardEl = track.querySelector('.cxq__card');
        var step = cardEl ? cardEl.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(btn.getAttribute('data-cxq-nav')), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 300);
  }

  // ---------- In den Warenkorb ----------
  var toastEl = null, toastTimer = null;
  function toast(text) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'cxx__toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = text;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }
  function addToCart(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.textContent;
    btn.textContent = 'Wird hinzugefügt …';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-cxx-add')), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Fehler');
      btn.textContent = '✓ Im Warenkorb';
      btn.classList.add('is-added');
      toast('„' + (btn.getAttribute('data-cxx-title') || 'Artikel') + '“ liegt im Warenkorb');
      var onCart = (window.themeVariables && themeVariables.settings && themeVariables.settings.pageType === 'cart') || /^\/cart(\/|$|\?)/.test(location.pathname + location.search);
      // Theme-Komponenten (Zähler im Header, Drawer) aktualisieren sich über cart:refresh; auf der Warenkorbseite
      // neu laden, damit die Positionen und Summen stimmen.
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (onCart) setTimeout(function () { location.reload(); }, 600);
      setTimeout(function () { btn.removeAttribute('aria-busy'); btn.textContent = label; btn.classList.remove('is-added'); }, 4000);
    }).catch(function (err) {
      console.error('cx-xsell:', err);
      btn.removeAttribute('aria-busy'); btn.textContent = label;
      toast('Das hat gerade nicht geklappt – bitte auf der Produktseite in den Warenkorb legen.');
    });
  }

  function parseList(s) { try { var v = JSON.parse(s || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }

  function initRoot(el) {
    if (el.dataset.cxxReady) return;
    el.dataset.cxxReady = '1';
    var mode = el.getAttribute('data-cx-xsell') || 'product';
    var url = el.getAttribute('data-cx-xsell-url');
    if (!url) return;
    var max = Math.max(1, Number(el.getAttribute('data-max')) || 6);
    var ids = mode === 'cart' ? parseList(el.getAttribute('data-cart-ids')) : [el.getAttribute('data-product-id')];
    ids = ids.filter(Boolean);
    if (!ids.length) { el.hidden = true; return; }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cxx-add]');
      if (b) { e.preventDefault(); addToCart(b); }
    });
    // Bild lädt nicht: Fläche leer lassen statt Fehlersymbol
    el.addEventListener('error', function (e) { if (e.target && e.target.tagName === 'IMG') e.target.style.visibility = 'hidden'; }, true);
    load(url).then(function (data) {
      var items = pick(data, ids, ids, max);
      if (!items.length) { el.hidden = true; return; }
      render(el, items, el.getAttribute('data-title'));
      if (mode === 'product' && el.getAttribute('data-hide-related') === 'true') document.documentElement.classList.add('cx-xsell-has');
    }).catch(function (err) { console.error('cx-xsell:', err); el.hidden = true; });
  }

  function init() { document.querySelectorAll('[data-cx-xsell]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.CXXsell = { init: init, pick: pick };
})();
